import { useTranslation } from 'react-i18next';
import { Icon } from '../Icon.js';

// ── "No se está cobrando dinero real" ────────────────────────────────────────
// 2026-08-31. Existe por un caso concreto: la instalación corrió tres meses en
// modo prueba de Stripe sin que nadie lo supiera. Una cuenta figuraba con
// suscripción activa de $150 al mes que nunca movió un peso, porque la llave
// cargada era `sk_test_` y nada en pantalla lo decía.
//
// Por eso el aviso es PERMANENTE y no se puede cerrar. Un banner descartable
// se cierra el primer día y no se vuelve a ver — que es exactamente el modo de
// falla que esto previene. Molesta a propósito: mientras moleste, se sabe.
//
// Se muestra en Facturación y en el panel de cuentas, los dos lugares donde
// alguien mira números de dinero y podría creerlos reales.

export interface StripeTestModeBannerProps {
  /** Falso o indefinido = no se pinta nada. En modo real el aviso desaparece
   *  entero; no hay una versión "verde" que diga que todo está bien, porque un
   *  aviso que siempre está deja de leerse. */
  visible: boolean | undefined;
}

export function StripeTestModeBanner({ visible }: StripeTestModeBannerProps) {
  const { t } = useTranslation();
  if (!visible) return null;

  return (
    <div
      role="status"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--evo-space-2)',
        padding: 'var(--evo-space-2) var(--evo-list-pad-x)',
        // Tokens reales del DS: el relleno sutil de advertencia y el ámbar
        // para borde y texto — los mismos que usa el Pill tone="amber".
        background: 'var(--evo-fill-warning)',
        borderBottom: '1px solid var(--evo-amber)',
        color: 'var(--evo-amber)',
        fontFamily: 'var(--evo-font)',
        fontSize: 'var(--evo-fs-label)',
        flexShrink: 0,
      }}
    >
      <Icon name="alert" size={14} />
      <span>
        <strong>{t('billing.testMode.title')}</strong>{' '}
        {t('billing.testMode.description')}
      </span>
    </div>
  );
}
